import { useMutation, useQueryClient } from '@tanstack/react-query';
import { cookingSessionRequests } from '@/lib/api/requests/cooking-sessions';
import type { BulkActionCookingSessionsPayload, CreateCookingSessionPayload, UpdateCookingSessionPayload } from '@/types/cooking-session';
import { cookingSessionKeys } from './keys';
import { orderKeys } from '@/hooks/orders/keys';

export function useCreateCookingSession() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateCookingSessionPayload) => cookingSessionRequests.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: cookingSessionKeys.all });
    },
  });
}

export function useUpdateCookingSession() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: UpdateCookingSessionPayload }) =>
      cookingSessionRequests.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: cookingSessionKeys.all });
      queryClient.invalidateQueries({ queryKey: orderKeys.all });
    },
  });
}

export function useNextCookingSessionStage() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => cookingSessionRequests.nextStage(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: cookingSessionKeys.all });
    },
  });
}

export function useDeleteCookingSession() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => cookingSessionRequests.remove(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: cookingSessionKeys.all });
    },
  });
}

export function useBulkActionCookingSessions() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: BulkActionCookingSessionsPayload) => cookingSessionRequests.bulkAction(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: cookingSessionKeys.all });
    },
  });
}
